import { useState, useEffect } from 'react';

/**
 * Hook to track online/offline status with debounce to avoid flickers.
 */
export const useOnlineStatus = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    let timeout;
    const goOnline = () => {
      clearTimeout(timeout);
      setIsOnline(true);
    };
    const goOffline = () => {
      // Small debounce to avoid flicker on brief disconnects
      timeout = setTimeout(() => setIsOnline(false), 1000);
    };

    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);
    return () => {
      clearTimeout(timeout);
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);

  return isOnline;
};
